import React from 'react';
import { UiItemConfig } from './types';

type RegistryContextType = {
  register: (btn: UiItemConfig) => void;
  unregister: (id: string) => void;
};

export const RichEditUiRegistryContext =
  React.createContext<RegistryContextType | null>(null);
